import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { TabViewTableSkeleton } from '@/components/TabView';
import { FilesTableContainer } from '@/containers/Workspace.File/FilesTableContainer';
import { FolderStateContext } from '@/containers/Workspace.Folder/Context';
import { WorkspaceObjectType } from '@/enums';
import { FilesTable, FilesTableLoadingContext } from '@/screens/Workspace.FilesTable';
import { useAppSelector } from '@/store';
import type { WorkspaceObjectCapabilities } from '@/types';
import styles from './style/Workspace.Folder.module.css';

const FolderTabFiles = () => {

  const loading = useContext(FilesTableLoadingContext);

  return (
    <div className={styles.tableWrap}>
      {loading
        ? <TabViewTableSkeleton />
        : (
          <div className={styles.root}>
            <div className={styles.wrap}>
              <FilesTable />
            </div>
          </div>
        )
      }
    </div>
  );
};

const WithState = () => {
  const { object } = useContext(FolderStateContext);
  const workspaceBrandsEnabled = useAppSelector(state => state.features.workspaceBrands);

  const apiClient = useChatApiClient();

  const query = useQuery({
    queryKey: [
      `get:workspaces/objects`,
      object.workspaceId,
      object.id,
    ],
    queryFn: () => {
      return apiClient.workspaces.fetchWorkspaceFiles({
        workspaceId: object.workspaceId,
        objectId: object.id,
      }).then(res => ({
        ...res,
        items: res.items.filter(f => workspaceBrandsEnabled ? true : f.object.typeId !== WorkspaceObjectType.Brand),
      }));
    },
  });

  return (
    <FilesTableContainer
      parentObject={object}
      data={query.data?.items || []}
      isLoading={query.isLoading}
      breadcrumbs={query.data?.breadcrumbs || []}
      capabilities={query.data?.capabilities as WorkspaceObjectCapabilities<WorkspaceObjectType.Folder>}>
      <FolderTabFiles />
    </FilesTableContainer>
  );
};

export { WithState as FolderTabFiles };
export default WithState;